import { inject, provide } from "vue";

let uid = 0;

// Creates a hook that injects the definition into the child components.
// - A one-time unique ID is created for the exported hook.
// - The Provide function provides the value to the children
// - The inject function gets the value from the context
export default function provideHook<T>(definition: T) {
  const id = `$_provideHook_${++uid}`;
  const hook = (...args) => {
    const instance = inject(id, null);
    if (instance) return instance;
    const hook = (definition as any)(...args);
    provide(id, hook);
    return hook;
  };
  return hook as T;
}
